
routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

export default function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	$locationProvider.html5Mode(true)

  	$stateProvider
    .state('app.reportStudent', {
            abstract: false,
            url: '/reports/estudiante',
            template: require('./report-student/reportStudent.html'),
            controller: 'reportStudentController',
            controllerAs:'reportStudent'
	})

}



// WEBPACK FOOTER //
// ./src/app/reports/reports.route.js